var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.6374 12.5282L16.1984 9.89445L8.74348 17.3494C7.33759 18.7552 6.66652 18.6665 6.19789 18.1979C5.72925 17.7293 5.64054 17.0582 7.04642 15.6523L14.5013 8.1974L11.8675 7.75837C11.289 7.66197 10.8648 7.16143 10.8648 6.57476L10.8648 6.42389C10.8648 5.69551 11.5084 5.13506 12.2299 5.23527L17.4167 5.95558C17.9484 6.02941 18.3664 6.44739 18.4402 6.9791L19.1605 12.1659C19.2607 12.8874 18.7003 13.531 17.9719 13.531L17.821 13.531C17.2344 13.531 16.7339 13.1069 16.6374 12.5282Z",
  fill: "#ffffff"
});

function SvgExtLinkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtLinkWhite);
export default __webpack_public_path__ + "static/media/ext-link-white.fa19a049.svg";
export { ForwardRef as ReactComponent };